export const heroData = [
  {
    id: 1,
    lightTxt: false,
    buttonTxt: "Get Started",
    title: "Proudly Serving All of California",
    description: "Click below to contact us now!",
    linkImg: "images/blue-door4.jpg",
  },
  {
    id: 2,
    lightTxt: true,
    buttonTxt: "Read More",
    title: "Slide Two",
    description: "Second slide ......",
    linkImg: "images/img-5.jpg",
  },
  {
    id: 3,
    lightTxt: true,
    buttonTxt: "More Info",
    title: "Slide Three",
    description: "Third slide ......",
    linkImg: "images/img-1.jpg",
  },
];
